import CalendarDayMenu from './CalendarDayMenu/CalendarDayMenu';
import DayMenuOtherUser from './CalendarDayMenu/DayMenuOtherUser';
import EventMenu from './CalendarDayMenu/EventMenu';
import MenuDropdown from './MenuDropdown';
import SettingsOverlay from './SettingsOverlay';
import ShareCalendarOverlay from './ShareCalendarOverlay';
import ProfileFullMenu from '../Pages/Profile/ProfileFullMenu';
import ImageViewerModal from '../components/ImageViewerModal';
import EventWindow from '../Windows/EventWindow/EventWindow';
import HelpMenuContent from './HelpMenuContent';
import TestResultMenu from './TestResultMenu';
import ImagePredictionMenu from './ImagePredictionMenu';

function Menus() {
  return (
    <>
      <CalendarDayMenu />
      <ProfileFullMenu />
      <DayMenuOtherUser />
      <EventMenu />
      <MenuDropdown />
      <SettingsOverlay />
      <ShareCalendarOverlay />
      <ImageViewerModal />
      <EventWindow />
      <HelpMenuContent />
      <TestResultMenu />
      <ImagePredictionMenu />
    </>
  );
}

export default Menus;
